/**
 * Express window = 50% of the package `dueDays`, rounded to a whole number.
 * Ties (.5) round to the nearest **even** integer (IEEE / “bankers”), so:
 * 7→4, 14→7, 21→10.
 */
export function expressDeliveryDaysFromPackageDueDays(dueDays: number): number {
	const d = Math.floor(Number(dueDays));
	if (!Number.isFinite(d) || d <= 0) return 0;
	const half = d / 2;
	const fl = Math.floor(half);
	const frac = half - fl;
	if (frac < 0.5 - 1e-9) return fl;
	if (frac > 0.5 + 1e-9) return fl + 1;
	return fl % 2 === 0 ? fl : fl + 1;
}
